import { render } from "./SwapWidget.vue?vue&type=template&id=540b96e2&scoped=true"
import script from "./SwapWidget.vue?vue&type=script&lang=js"
export * from "./SwapWidget.vue?vue&type=script&lang=js"

import "./SwapWidget.vue?vue&type=style&index=0&id=540b96e2&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-540b96e2"],['__file',"resources/js/components/SwapWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "540b96e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('540b96e2', __exports__)) {
    api.reload('540b96e2', __exports__)
  }
  
  module.hot.accept("./SwapWidget.vue?vue&type=template&id=540b96e2&scoped=true", () => {
    api.rerender('540b96e2', render)
  })

}


export default __exports__